import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Group } from '../models/group';
import { GroupService } from './group.service';

@Injectable()
export class GroupResolver implements Resolve<Group> {
    constructor(private groupService: GroupService) { }

    resolve(route: ActivatedRouteSnapshot) {
        let groupRef = this.groupService.getById(route.paramMap.get('id'));
        return new Promise<Group>((resolve, reject) => {
            groupRef.valueChanges().subscribe(res => {
                res.id = route.paramMap.get('id');
                resolve(new Group(res));
            }, reject)
        })
    }
}